const getComplexExp = (values) => {

  if(Array.isArray(values) && values.length){
    values.sort((a,b) => a-b)
    const lastIndex = values.length-1
    if(lastIndex > 1 && (values[lastIndex] - values[0] + 1) === values.length){
      return `${values[0]}-${values[lastIndex]}`
    }else{
      return values.join(',')
    }
  }
  return '*'
}

export const getCronExp = ({ minutes, hours, months, weekdays, monthdays }) => {
  const minutesExp = isNaN(parseInt(minutes)) ? '*' : minutes
  const hoursExp = isNaN(parseInt(hours)) ? '*' : hours

  const monthdaysExp = getComplexExp(monthdays) 
  const monthsExp =getComplexExp(months)
  const weekdaysExp =getComplexExp(weekdays)

  // const monthdaysExp = monthdays || '*'
  // const monthsExp = months || '*'
  // const weekdaysExp = weekdays || '*'

  const cronExp = `${minutesExp} ${hoursExp} ${monthdaysExp} ${monthsExp} ${weekdaysExp}`

  return cronExp
}
